module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/book/book-edit/book-edit.component.scss
// module id = ./src/app/book/book-edit/book-edit.component.scss
// module chunks = main